export default "/images/crypto_environments/ethereum__fire_interest__icon.png";